import tennisActionImage from "../../assets/blog/tennis-return-action.webp";

export const tennisReturnStrategy = {
  id: 5,
  slug: "tennis-return-strategy",
  title: "Tennis Return Strategy: How to Neutralize a Fast Serve",
  excerpt: "Facing a big server? Don't panic. Learn the techniques to neutralize their power and get the point started on your terms.",
  seoTitle: "Tennis Return Strategy Against Fast Serves | Racketly",
  seoDescription: "Improve your tennis return against fast serves with a timed split step, shorter backswing and clear target zones. Start the rally with more control.",
  date: "2026-01-02",
  category: "Tennis",
  image: tennisActionImage,
  imageWidth: 1200,
  imageHeight: 1500,
  imageAlt: "A tennis player preparing to strike the ball on an outdoor court",
  imageCaption: "Tennis action on an outdoor hard court.",
  imageCredit: "Florian Doppler on Pexels",
  imageCreditUrl: "https://www.pexels.com/photo/photo-of-man-playing-tennis-3818832/",
  imageLicense: "Pexels License",
  imageLicenseUrl: "https://www.pexels.com/license/",
  imagePosition: "center 40%",
  content: `
  <p class="mb-4">The return of serve is arguably the second most important shot in tennis, yet it is often the least practiced. Against a big server, your goal isn't necessarily to hit a winner, but to neutralize the point.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">The Split Step</h2>
  <p class="mb-4">Timing is everything. You must land your split step exactly as your opponent makes contact with the ball. This loads your legs and allows you to explode in the direction of the serve.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">Shorten the Backswing</h2>
  <p class="mb-4">You don't have time for a full swing against a 100mph+ serve. Turn your shoulders and block the ball back. Use the server's pace against them.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">Target Zones</h2>
  <p class="mb-4">Aim deep down the middle. This takes away the angles for the server's next shot and forces them to move out of the way of the ball, often inducing an awkward error.</p>
`,
};
